export default __webpack_public_path__ + "static/media/chantilly6.e097d473.jpg";